/**
 * @file Custom hook for fetching all agents that would be listed in our marketplace.
 */
import { useQuery } from "@tanstack/react-query";
import { listAgents } from "@/services/DataService";
import type { MarketplaceAgentsResponse } from '@/types/agent';

export const useMarketplaceAgents = () => {
  return useQuery<MarketplaceAgentsResponse>({
    queryKey: ['marketplace-agents'],
    queryFn: listAgents,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};